var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSearchDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#50A9FC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M875.98 51c.202 0 .364-.06.485-.182l2.603-2.664c.283-.282.283-.565 0-.847l-5.146-5.207c.848-1.454 1.271-3.028 1.271-4.723 0-2.664-.938-4.935-2.815-6.812-1.877-1.877-4.127-2.815-6.751-2.815-2.624 0-4.884.938-6.781 2.815-1.897 1.877-2.846 4.148-2.846 6.812 0 2.664.949 4.935 2.846 6.811 1.897 1.877 4.157 2.816 6.781 2.816 1.695 0 3.31-.464 4.844-1.393l5.086 5.207c.12.121.262.182.423.182zm-10.353-7.75c-1.615 0-2.997-.575-4.148-1.726-1.15-1.15-1.725-2.532-1.725-4.147 0-1.615.575-2.997 1.725-4.148 1.15-1.15 2.533-1.725 4.148-1.725 1.615 0 2.987.585 4.117 1.756 1.13 1.13 1.695 2.502 1.695 4.117 0 1.615-.565 2.997-1.695 4.147-1.13 1.15-2.502 1.726-4.117 1.726z",
    transform: "translate(-1117 -612) translate(261 585)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchDesktop);
export default __webpack_public_path__ + "static/media/ic-search-desktop.f652442146ef9b12c9e92b55e64ecab4.svg";
export { ForwardRef as ReactComponent };